import React, { useState, useEffect } from "react";
import UserIcon from "../../icons/UserIcon";

const defaultImg = "https://www.kindpng.com/picc/m/252-2524695_dummy-profile-image-jpg-hd-png-download.png";

const Avatar = ({ 
  src, 
  className = "w-12 h-12", 
  bgColor = "bg-gradient-to-br from-gray-100 to-slate-100", 
  iconColor = "text-gray-400",
  showLoadingState = true 
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  // Reset error state when src changes
  useEffect(() => {
    setImageError(false);
    setImageLoaded(false);
  }, [src]);

  // Show UserIcon if no src, src is default image, or image failed to load
  if (!src || src === defaultImg || imageError) {
    return (
      <UserIcon 
        className={className} 
        bgColor={bgColor} 
        iconColor={iconColor} 
      />
    );
  }

  return (
    <>
      {showLoadingState && !imageLoaded && (
        <UserIcon 
          className={className} 
          bgColor={bgColor} 
          iconColor={iconColor} 
        />
      )}
      <img
        src={src}
        alt=""
        className={`${className} object-cover rounded-full border-2 border-gray-100 ${!imageLoaded && showLoadingState ? 'hidden' : ''}`}
        onError={handleImageError}
        onLoad={handleImageLoad}
      />
    </>
  );
};

export default Avatar;